@use "~theme/typography";

.group {
  display: inline-flex;
  flex-wrap: wrap;
  column-gap: 32px;
}

.error {
  @include typography.caption;
  color: var(--red);
  margin: 0;
}
